import { ArrowRightIcon, FileInput, SparksAIIcon, Typography } from "@cpj-ai/panel-npm-package";
import { Button } from "@heroui/react";
import { useState } from "react";
import { useAiJobPositionCreator } from "./hooks/useAiJobPositionCreator";
import AiJobPositionCreatorLayout from "./layout";
interface IFileJobCreatorProps {
  handleNextStep: () => void;
  setSelectedMethod: (method: "voice" | "file" | null) => void;
}

const FileJobCreator = ({ handleNextStep, setSelectedMethod }: IFileJobCreatorProps) => {
  const [file, setFile] = useState<File>();
  const { handleAnalyzeWithAI, isAnalyzing } = useAiJobPositionCreator({ handleNextStep });

  return (
    <AiJobPositionCreatorLayout description="Upload a file containing your job post requirements. Our AI will analyze the file and automatically fill in the job details for you. This is designed for your convenience, but you can always skip and create a job post manually if you prefer.">
      <div className="pb-6 pt-3">
        <FileInput
          handleChange={(file) => setFile(file)}
          isFetching={false}
          isLoading={false}
          isDisabled={isAnalyzing}
          setFile={setFile}
          value={{ file: file || undefined }}
          accept={{
            "audio/wav": [".wav"],
            "audio/webm": [".webm"],
            "audio/mpeg": [".mp3"],
            "application/pdf": [".pdf"],
            "application/msword": [".doc"],
            "application/vnd.openxmlformats-officedocument.wordprocessingml.document": [".docx"],
            "text/plain": [".txt"],
          }}
          dropZoneEndContent={
            <div className="flex items-center justify-center gap-2 mt-2 ">
              <SparksAIIcon className="w-6 h-6" stroke="#DD7880" />
              <Typography className="text-base text-primary-300">Analysis with CPJ AI</Typography>
            </div>
          }
        />
      </div>
      <div className="flex flex-col gap-2">
        <Button
          color="primary"
          startContent={<SparksAIIcon className="w-6 h-6 stroke-white" />}
          onPress={() => file && handleAnalyzeWithAI(file)}
          isDisabled={isAnalyzing}
          isLoading={isAnalyzing}
          fullWidth
        >
          {isAnalyzing ? "Analyzing..." : "Analyze with AI"}
        </Button>
        <Button
          variant="bordered"
          color="primary"
          className="w-full"
          startContent={<ArrowRightIcon className="w-6 h-6 rotate-180 mb-1.5 -mr-1 stroke-primary-500" />}
          onPress={() => setSelectedMethod(null)}
        >
          Change Method
        </Button>
      </div>
    </AiJobPositionCreatorLayout>
  );
};

export default FileJobCreator;
